<template>
  <DialogContent
    :dialog-value="showCookiesSettings"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :show-back-arrow="showCookiesDocument"
    :show-close-button="false"
    show-title-before-scroll
    show-title-in-content
    :title="showCookiesDocument ? documentContent.title : $t('cookiesConsent.settings.title')"
    :title-left="!showCookiesDocument"
    text-class="px-4 px-md-10"
    :mobile-buttons="showCookiesDocument ? [] : buttons"
    persistent
    @clickBack="showCookiesDocument = false"
  >
    <template #text>
      <template v-if="!showCookiesDocument">
        <i18n path="cookiesConsent.settings.link" class="mb-2" tag="div">
          <template #hereLink>
            <span class="link" @click="showLegal">{{ $t('here') }}</span>
          </template>
        </i18n>
        <div>
          {{ $t('cookiesConsent.settings.description') }}
        </div>
        <CollapseList
          :items="cookiesConsentSettingsItems"
          :switch-values="cookiesSettings"
          :has-borders="false"
          class="mt-4"
          @change="(key, value) => updateCookieSettings({ type: key, value })"
        />
      </template>
      <div v-else v-html="documentContent.content"></div>
    </template>
    <template v-if="!$vuetify.breakpoint.smAndDown && !showCookiesDocument" #actions>
      <v-row class="pb-10 px-10 pt-6" no-gutters>
        <v-spacer class="d-none d-sm-block" />
        <v-col cols="12" sm="auto">
          <v-btn
            data-cy="saveCookieSettingsButton"
            class="mr-4"
            color="tetrary"
            @click.prevent="acceptCookies"
          >
            {{ $t('cookiesConsent.settings.save') }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-btn data-cy="acceptAllCookiesButton" color="primary" @click.prevent="acceptAllCookies">
            {{ $t('cookiesConsent.acceptAll') }}
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </DialogContent>
</template>

<script>
import CollapseList from '@/components/Molecules/CollapseList';
import cookiesConsent from '@/mixins/cookiesConsent';
import lodash from 'lodash';
import DialogContent from '@/components/Atoms/DialogContent';

export default {
  name: 'CookiesConsentSettings',
  components: {
    DialogContent,
    CollapseList
  },
  mixins: [cookiesConsent],
  computed: {
    cookiesConsentSettingsItems() {
      let consentListCopy = lodash.cloneDeep(this.consentList);

      consentListCopy.forEach((item, index) => {
        if (this.$t('cookiesConsent.settings.items')[item.identifier] !== undefined) {
          Object.assign(
            consentListCopy[index],
            this.$t('cookiesConsent.settings.items')[item.identifier]
          );
        } else {
          consentListCopy.splice(index, 1);
        }
      });
      return consentListCopy;
    },
    buttons() {
      return [
        {
          events: {
            click: () => {
              this.acceptAllCookies();
            }
          },
          text: this.$t('cookiesConsent.acceptAll')
        },
        {
          props: {
            color: 'tetrary'
          },
          events: {
            click: () => {
              this.acceptCookies();
            }
          },
          text: this.$t('cookiesConsent.settings.save')
        }
      ];
    }
  },
  methods: {
    showLegal() {
      this.showCookiesDocument = true;
    }
  }
};
</script>
